// extracted by mini-css-extract-plugin
export var text = "_3l-0";